/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D switch button
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function Switch({
    status,
    barColor = "#0366b2",
    knobColor = "#0366b2",
    disabledKnobColor = "#f2f2f2",
    disabledBarColor = "#737373",
    fontColor = "#c6c6c6",
    borderColor = "#737373",
    textSize,
    textSizeDecimal,
    textWidth,
    radius = 0.1,
    width,
    height,
    aframeClasses,
    ...otherAttributes
}) {
    return (
        <a-entity class="Switch" {...otherAttributes}>
            <a-plane
                width={width}
                height={height}
                color={status ? barColor : disabledBarColor}
                position={`${width / 2} 0 0`}
                class={aframeClasses}
            >
                <a-circle
                    class={aframeClasses}
                    radius={radius * 0.9}
                    position={`${status ? width / 2 : -width / 2} 0 0.001`}
                    color={status ? knobColor : disabledKnobColor}
                >
                    {!status && (
                        <a-ring
                            radius-inner={radius * 0.9}
                            radius-outer={radius}
                            color={borderColor}
                        />
                    )}
                </a-circle>
                <Text
                    text={status ? "On" : "Off"}
                    position={`${width} 0 0`}
                    align="left"
                    width={textWidth}
                    size={textSize}
                    sizeDecimal={textSizeDecimal}
                    color={fontColor}
                />
            </a-plane>
        </a-entity>
    );
}

Switch.propTypes = {
    status: PropTypes.bool.isRequired,
    textWidth: PropTypes.PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default Switch;
